import MainLayout from "@/components/layout/admin/MainLayout.vue";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import axios from "axios";
import CONFIG from "@/assets/js/config.custom.js";
import flatPickr from 'vue-flatpickr-component';
import Select2Multiple from 'v-select2-multiple-component';
import upLoad from '@/assets/img/upload_photo3.jpg';
import { required, minValue, maxLength, requiredIf } from "vuelidate/lib/validators";
import { canManageHistory } from "@/services/PaymentAccessService";

export default {
  name: 'tuitionPaymentDetail',
  components: {
    MainLayout,
    Loading,
    flatPickr,
    Select2Multiple,
  },

  data() {
    return {
      isLoading: true,
      noDataMsg: CONFIG.NO_DATA_FOUND,
      tuitionPaymentInfo: {},
      PaymentStatus: CONFIG.PAYMENT_STATUS,
      TuitionPaymentStatus: CONFIG.TUITION_PAYMENT_STATUS,
      PaymentHistories: [],
      PaymentHistoryStatus: [],
      STATUS: CONFIG.PAYMENT_HISTORY_STATUS_VAL,
      paymentData: {
        student_payment_id: this.$route.params.studentPaymentId,
        amount: '',
        payment_method_id: '',
        receiver: this.$store.state.user.name,
        payment_date: new Date().toISOString().split('T')[0],
        status: CONFIG.PAYMENT_HISTORY_STATUS_VAL.APPROVED,
        remark: '',
        payment_screenshot: null,
      },
      ssImage: '',
      paymentMethodArr: null,
      TuitionPaymentStatusText: CONFIG.TUITION_PAYMENT_STATUS_TEXT,
      statusBadge: CONFIG.PAYMENT_HISTORY_STATUS_TEXT,
      ParentStatus: CONFIG.PARENT_PAYMENT_STATUS,
      ParentStatusText: CONFIG.PARENT_PAYMENT_STATUS_TEXT,
      imageLargeMsg: CONFIG.IMAGE_TOO_LARGE,
      upLoad,
      isEditing: false,
      editId: null,
      errors: {},
      submitted: false,
      grandTotalAmt: 0,
      currency_txt: '',
    };
  },

  validations: {
    paymentData: {
      amount: { required, minValue: minValue(0) },
      payment_method_id: {
        required: requiredIf(function() {
          return parseInt(this.paymentData.status) === this.STATUS.APPROVED;
        }),
        notZero: function(value) {
          if (parseInt(this.paymentData.status) !== this.STATUS.APPROVED) return true;
          return value != 0 && value != null;
        }
      },
      receiver: { maxLength: maxLength(100) },
      payment_date: {
        required: requiredIf(function() {
          return parseInt(this.paymentData.status) === this.STATUS.APPROVED;
        }),
      },
      status: { required },
      remark: {  maxLength: maxLength(1000) },
    },
    ssImage: {
      required: requiredIf(function () {
        return parseInt(this.paymentData.status) === this.STATUS.APPROVED;
      }),
    },
  },

  computed: {
    studentPaymentId() {
      return this.$route.params.studentPaymentId;
    },

    displayPaymentStatus() {
      const totalPaid = this.PaymentHistories.reduce((sum, history) => {
        if (Number(history.status) === this.STATUS.APPROVED) {
          return sum + Number(history.amount);
        }
        return sum;
      }, 0);

      let statusKey;

      if (totalPaid === 0) {
        statusKey = this.ParentStatus.NOT_PAID;
      } else if (totalPaid < this.grandTotalAmt) {
        statusKey = this.ParentStatus.PARTIAL_PAID;
      } else {
        statusKey = this.ParentStatus.FULLY_PAID;
      }
      return this.ParentStatusText[statusKey];
    },

    totalApprovedAmount() {
      return this.PaymentHistories.reduce((sum, history) => {
        if (Number(history.status) === this.STATUS.APPROVED) {
          return sum + Number(history.amount || 0);
        }
        return sum;
      }, 0);
    },

    totalRemainingAmount() {
      const netTotal = Number(this.tuitionPaymentInfo.net_total_amt || 0);
      const remaining = netTotal - this.totalApprovedAmount;

      return remaining > 0 ? remaining : 0;
    },

    filteredPaymentStatus() {
      return Object.entries(CONFIG.PAYMENT_HISTORY_STATUS_TEXT)
      .filter(([key]) => {
        const statusKey = parseInt(key);

        if (key === '0') return false;
        if (!this.isEditing) {
          return statusKey === this.STATUS.ADMIN_REQUEST || statusKey === this.STATUS.APPROVED;
        }
        const currentRecord = this.PaymentHistories.find(h => h.id === this.editId);
        const originalStatus = currentRecord ? parseInt(currentRecord.status) : null;

        if (originalStatus === this.STATUS.APPROVED || originalStatus === this.STATUS.REJECTED) {
          return statusKey !== this.STATUS.ADMIN_REQUEST;
        }
        return true; 
      })
      .map(([key, value]) => {
        return {
          id: key,
          text: value
        };
      });
    },
  },

  watch: {
    'paymentData.status': function(newVal) {
      const status = parseInt(newVal);
      if (status === this.STATUS.APPROVED) {
        this.paymentData.payment_date = new Date().toISOString().split('T')[0];
      } else if (status === this.STATUS.ADMIN_REQUEST) {
        this.paymentData.payment_date = null;
        this.paymentData.payment_method_id = null;
      } else {
        this.paymentData.receiver = this.$store.state.user.name;
      }
    }
  },

  methods: {
    /**
     * Redirect to statement list
     */
    showStatementList() {
      this.$router.push({
          path: "/student/statement/list"
      });
    },

    getTuitionPaymentDetailByPlan() {
      this.isLoading = true;
      axios.get(`student/statement/detail/${this.$route.params.tuitionPaymentId}/tuition-payment/${this.$route.params.studentPaymentId}`)
      .then((response) => {
        if (response.data.success === true) {
          this.isLoading = false;
          this.tuitionPaymentInfo = response.data.data;
        }
      })
      .catch(error => {
        this.isLoading = false;
        if (error.response.status == 401) {
          this.$store.commit('logout');
          window.location.replace('login');
        }
        console.error("Error fetching payment info by plan:", error);
      })
    },

    /**
     * Redirect to statement detail
     */
    showStatementDetail() {
      if (this.$route.query.from === 'payment-list') {
        this.$router.push({ name: 'paymentList' });
        return;
      }
      this.$router.push({
          path: `/student/statement/detail/${this.$route.params.tuitionPaymentId}`
      });
    },
    reject() {
      axios.post(`student/statement/detail/${this.$route.params.tuitionPaymentId}/tuition-payment/${this.$route.params.studentPaymentId}/reject`)
        .then((response) => {
          if (response.status == 200) {
            window.location.reload();
          }
        })
        .catch(error => {
          console.error("Error rejecting payment:", error);
        })
    },

    /**
     * Approve payment
     */
    approve() {
      axios.post(`student/statement/detail/${this.$route.params.tuitionPaymentId}/tuition-payment/${this.$route.params.studentPaymentId}/approve`)
        .then((response) => {
          if (response.status == 200) {
            window.location.reload();
          }
        })
        .catch(error => {
          console.error("Error approving payment:", error);
        })
    },

    getHistoryList() {
      axios.get(`student-payment/${this.studentPaymentId}/payment-history/list`)
      .then((response) => {
        this.PaymentHistories = response.data.histories;
        this.currency_txt = response.data.currency_txt;
      })
      .catch(error => {
        console.error("Error tuition payment history:", error);
      });
    },

    openImage(imagePath) {
      window.open(imagePath, '_blank');
    },

    onFileChange(e) {
      this.paymentData.image = e.target.files[0];
    },

    submitPayment() {
      this.submitted = true;
      this.errors = {};

      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }
      this.isLoading = true;

      const submissionData = { ...this.paymentData };
      const currentStatus = parseInt(submissionData.status);
      if (currentStatus === this.STATUS.ADMIN_REQUEST) {
        submissionData.payment_method_id = null;
        submissionData.payment_date = null;
      }
      const payload = {
        ...submissionData,
        payment_screenshot: this.ssImage,
        image_remove: this.ssImage === '' || this.ssImage === null,
      };
      let url = this.isEditing 
              ? `student-payment/${this.studentPaymentId}/payment-history/update/${this.editId}` 
              : `student-payment/${this.studentPaymentId}/payment-history/store`;

      axios.post(url, payload)
      .then(res => {
        if (res.data.status === 'success') {
          this.$notification.success(this.isEditing ? "Payment history updated successfully" : "Payment history added successfully", {
            timer: 3,
            position: "bottomCenter"
          });
          this.resetForm();
          this.getHistoryList();
        }
      })
      .catch(error => {
        if (error.response && error.response.status === 422) {
          this.errors = error.response.data.errors || {};
          const firstError = Object.values(this.errors)
            .find(messages => Array.isArray(messages) && messages.length)?.[0] || "Something went wrong.";
          this.$notification.error(firstError, {
            timer: 3,
            position: "bottomCenter"
          });
        } else {
          if (error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          console.error(this.isEditing ? "Payment history update api error:" : "Payment history create api error:", error);
          this.$notification.error("Something went wrong.", {
            timer: 3,
            position: "bottomCenter"
          });
        }
      })
      .finally(() => {
        this.isLoading = false;
      });
    },

    resetForm() {
      this.isEditing = false;
      this.submitted = false
      this.editId = null;
      this.paymentData = {
        student_payment_id: this.$route.params.studentPaymentId,
        amount: '',
        payment_method_id: 0,
        receiver: this.$store.state.user.name,
        payment_date: new Date().toISOString().split('T')[0],
        status: this.STATUS.APPROVED,
        remark: '',
      };
      this.ssImage = '';
    },

    removeImg() {
      this.ssImage = '';
      delete this.errors.payment_screenshot;
      document.getElementById('image').value = '';
    },

    imgUpload(e) {
      let files = e.target.files || e.dataTransfer.files;
      if (!files.length) {
        return null;
      } else {
        if (e.target.files[0].type.includes("image/")) {
          if (e.target.files[0].type == "image/gif") {
            this.$notification.error("File not supported!", {
              timer: 3,
              position: "bottomCenter",
            });
            return null;
          }
          let reader = new FileReader();
          reader.onload = (e) => {
            if (e.target.result.length > 5242880) {
              this.$notification.error(this.imageLargeMsg, {
                timer: 3,
                position: "bottomCenter",
              });
              document.getElementById('image').value = '';
            } else {
              this.ssImage = e.target.result;
              document.getElementById('image').value = '';
              delete this.errors.payment_screenshot;
            }
          }
          reader.readAsDataURL(files[0]);
        } else {
          this.$notification.error("File not supported!", {
            timer: 3,
            position: "bottomCenter",
          });
          return null;
        }
      }
    },

    getPaymentMethod() {
      axios.get('getPaymentMethod')
        .then(res => {
          let $defaultSelectOption = [{
            'id': 0,
            'text': 'Select Payment Method'
          }];
          this.paymentMethodArr = $defaultSelectOption.concat(res.data);
        }).catch((error) => {
          if (error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          this.isLoading = false;
        });
    },

    editDetailData(history) {
      this.isLoading = true;
      axios.get(`student-payment/${this.studentPaymentId}/payment-history/detail/${history.id}`)
      .then((response) => {
        if (response.data.status === 'success') {
          const data = response.data.data;
          this.isEditing = true;
          this.editId = data.id;
          this.paymentData.amount = Number(data.amount);
          this.paymentData.payment_method_id = data.payment_method_id;
          this.paymentData.receiver = data.receiver;
          this.paymentData.payment_date = data.payment_date;
          this.paymentData.status = data.status;
          this.paymentData.remark = data.remark;

          if (data.payment_screenshot) {
            this.ssImage = data.payment_screenshot;
          } else {
            this.ssImage = '';
          }

          const formElement = document.querySelector('.payment-create-form');
          if (formElement) {
            formElement.scrollIntoView({ behavior: 'smooth' });
          }
        }
      })
      .catch(error => {
        console.error("Error fetching history detail:", error);
          this.$notification.error("Could not retrieve record detail", {
              timer: 3,
              position: "bottomCenter"
          });
      })
      .finally(() => {
        this.isLoading = false;
      });
    },

    deleteHistory(id) {
      if (confirm("Are you sure you want to delete this payment history?")) {
        this.isLoading = true;
        axios.delete(`student-payment/${this.studentPaymentId}/payment-history/delete/${id}`)
        .then(res => {
          if (res.data.status === 'success') {
            this.$notification.success("Payment history deleted successfully", {
              timer: 3,
              position: "bottomCenter"
            });
            this.resetForm();
            this.getHistoryList();
          } else {
            this.$notification.error(res.data.message);
          }
        })
        .catch(error => {
          console.error("Payment History Api Delete Error:", error);
          this.$notification.error("Failed to delete the record.", {
            timer: 3,
            position: "bottomCenter"
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
      }
    },

    updateStatus(id, newStatus) {
      const actionText = newStatus === this.STATUS.APPROVED ? "approve" : "reject";

      if (!confirm(`Are you sure you want to ${actionText} this payment history?`)) {
        return;
      }
      if (newStatus === this.STATUS.APPROVED) {
        const historyItem = this.PaymentHistories.find(h => h.id === id);
        const amount = parseFloat(historyItem.amount) || 0;

        const existingApprovedSum = this.PaymentHistories
          .filter(h => Number(h.status) === this.STATUS.APPROVED && Number(h.id) !== Number(id))
          .reduce((sum, h) => sum + parseFloat(h.amount), 0);

        if ((existingApprovedSum + amount) > this.grandTotalAmt) {
          if (!confirm("Total History Amount will be exceeded Grand Total Amount. Are you sure to approve this history?")) {
            return;
          }
        }
      }

      this.isLoading = true;
      axios.post(`student-payment/${this.studentPaymentId}/payment-history/update-status/${id}`, { status: newStatus })
        .then(res => {
          if (res.data.status === 'success') {
            const actionText = newStatus === this.STATUS.APPROVED ? "approved" : "rejected";
            this.$notification.success(`Payment history ${actionText} successfully`, {
              timer: 3,
              position: "bottomCenter"
            });
            this.getHistoryList();
          }
        })
        .catch(error => {
          console.error("Status update error:", error);
          this.$notification.error("Failed to update status");
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    fetchGrandTotal() {
      const id = this.$route.params.studentPaymentId;
      axios.get(`/payment/${id}/grand-total`)
        .then(res => {
          this.grandTotalAmt = parseFloat(res.data.grand_total) || 0;
        })
        .catch(err => console.error("Error fetching total:", err));
    },

    /**
      * Check if user can modify payment history status when:
      * - Main payment status is Approved (1)
      * - payment_history_status is Fully Paid (2)
      * Only Principal (role 8) can modify in these cases
      * @returns {boolean}
      */
    canManageHistory(action, history) {
      return canManageHistory(action, history, this.$store.state.user);
    },

    pdfDownload(studentName, paymentId) {
      this.isLoading = true;
      const request = {
        params: {
          campus_id: this.$store.state.user.campus_id,
          payment_id: paymentId,
          class_id: this.tuitionPaymentInfo.class_id,
          is_tuition_pdf: true,
        },
        responseType: 'blob'
      };
      axios.get(`/payment/pdfDownload/${this.tuitionPaymentInfo.student_id}`, request)
      .then((response) => {
        var fileURL = window.URL.createObjectURL(new Blob([response.data]));
        var fileLink = document.createElement('a');
        fileLink.href = fileURL;
        let date = new Date();
        const fileName = `invoice_${studentName}_${date.getFullYear()}${(date.getMonth() + 1) > 9 ? '' : '0'}${date.getMonth()+1}${(date.getDate()) > 9 ? '' : '0'}${date.getDate()}.pdf`;
        fileLink.setAttribute('download', fileName);
        document.body.appendChild(fileLink);
        fileLink.click();
        this.isLoading = false;
      }).catch(error => {
        if (error.response && error.response.status == 401) {
          this.$store.commit('logout');
          window.location.replace('login');
        }
        this.isLoading = false;
        console.error("Invoice PDF download error:", error);
        this.$notification.error("Failed to download invoice PDF", {
          timer: 3,
          position: "bottomCenter"
        });
      });
    },

    downloadReceipt(historyId, studentName) {
      this.isLoading = true;
      const studentPaymentId = this.$route.params.studentPaymentId;
      axios.get(`student-payment/${studentPaymentId}/payment-history/receipt/${historyId}/pdf-download`, {
        responseType: 'blob'
      })
      .then((response) => {
        var fileURL = window.URL.createObjectURL(new Blob([response.data]));
        var fileLink = document.createElement('a');
        fileLink.href = fileURL;
        let date = new Date();
        const fileName = `receipt_${studentName}_${date.getFullYear()}${(date.getMonth() + 1) > 9 ? '' : '0'}${date.getMonth()+1}${(date.getDate()) > 9 ? '' : '0'}${date.getDate()}.pdf`;
        fileLink.setAttribute('download', fileName);
        document.body.appendChild(fileLink);
        fileLink.click();
        this.isLoading = false;
      }).catch(error => {
        if (error.response && error.response.status == 401) {
          this.$store.commit('logout');
          window.location.replace('login');
        }
        this.isLoading = false;
        console.error("Receipt PDF download error:", error);
        this.$notification.error("Failed to download receipt PDF", {
          timer: 3,
          position: "bottomCenter"
        });
      });
    },
  },

  mounted() {
    this.isLoading = true;
    this.PaymentHistoryStatus = Object.entries(CONFIG.PAYMENT_HISTORY_STATUS_TEXT)
    .filter(([key]) => !['0', '2'].includes(key))
    .map(([key, value]) => {
      return {
        id: key,
        text: value
      };
    });
    this.getTuitionPaymentDetailByPlan();
    this.getHistoryList();
    this.getPaymentMethod();
    this.fetchGrandTotal();
  },
};
